<section class="card__wrapper">
  <div class="content_wrapper">
    <slot class="card__slot">
      <ng-content></ng-content>
    </slot>
  </div>
</section>
